// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ryGn","content":"styles_content__2V-UJ"};